/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-facebook': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14.476 13.374l.415-2.533h-2.594V9.197c0-.693.362-1.369 1.524-1.369H15V5.671S13.93 5.5 12.907 5.5c-2.136 0-3.532 1.214-3.532 3.41v1.931H7v2.534h2.375V19.5h2.922v-6.125h2.179z" _fill="#fff"/>'
  }
})
